import { motion } from 'framer-motion'
import { useT } from '../i18n/locale.jsx'
import { BOOKING_URL } from '../config'
import { calAttrsForDate } from '../cal'

// Dată locală YYYY-MM-DD. NU folosesc toISOString() — ar converti la UTC și ar
// shifta ziua înapoi pe fusul RO (UTC+2/+3), deci ar pre-selecta ziua greșită.
function toISO(d) {
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${mm}-${dd}`
}

// Următoarele `count` zile lucrătoare (Luni–Vineri), cu nume de zi/lună localizate.
function nextWeekdays(count, days, months) {
  const out = []
  const d = new Date()
  d.setHours(0, 0, 0, 0)
  while (out.length < count) {
    d.setDate(d.getDate() + 1)
    const wd = d.getDay()
    if (wd >= 1 && wd <= 5) out.push({ day: days[wd], date: `${d.getDate()} ${months[d.getMonth()]}`, iso: toISO(d) })
  }
  return out
}

// Contact = climaxul honey. Fundalul vine din BgTransition (bone → honey #E8A33D).
// Textul e forest/ink (contrastul opus al honey-ului) ca să fie perfect lizibil.
export default function Contact() {
  const t = useT().contact
  const SLOTS = nextWeekdays(4, t.days, t.months)
  return (
    <section id="contact" data-theme="light" className="px-5 pb-16 pt-28 text-ink md:px-10 md:pb-24 md:pt-40">
      <div className="mx-auto max-w-site">
        <p className="mb-8 font-mono text-[12px] uppercase tracking-[0.1em] text-ink-soft">{t.eyebrow} ✦</p>

        {/* Programare call — slot picker */}
        <div className="mt-8 max-w-2xl md:mt-12">
          <p className="mb-3 flex items-center gap-2 font-mono text-[12px] lowercase tracking-[0.1em] text-ink">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-ink" />
            {t.available}
          </p>

          <ul className="border-t border-ink/30">
            {SLOTS.map((s, i) => (
              <motion.li
                key={s.date}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-40px' }}
                transition={{ duration: 0.5, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
              >
                <a
                  href={`${BOOKING_URL}?month=${s.iso.slice(0, 7)}&date=${s.iso}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  {...calAttrsForDate(s.iso)}
                  className="group flex items-center justify-between gap-6 border-b border-ink/30 py-5 transition-colors duration-300 ease-quint hover:bg-ink/[0.06]"
                >
                  <span className="flex items-baseline gap-4">
                    <span className="display text-3xl leading-none text-ink md:text-4xl">{s.day}</span>
                    <span className="font-mono text-sm text-ink-soft">{s.date}</span>
                  </span>
                  <span
                    aria-hidden
                    className="font-mono text-xl text-ink transition-transform duration-300 ease-quint group-hover:translate-x-1.5"
                  >
                    →
                  </span>
                </a>
              </motion.li>
            ))}
          </ul>

          <p className="mt-6 font-mono text-[12px] leading-relaxed text-ink-soft">{t.note}</p>
        </div>
      </div>
    </section>
  )
}
